import { createFileRoute } from '@tanstack/react-router';
import { PlanGuard } from '@/components/guards';
import { NewGoalRouteView } from '@/pages/workspaces/goals/new/routing';
import { validateNewGoalSearch } from '@/pages/workspaces/goals/new/search';
import { BUILDER_PLAN_SLUG } from '@/services/auth/plan-slugs';
import { LastWorkspaceResolver } from './-components';
import { ShowGoalsGate } from './-goals-route';

/** The goal create page. A static segment, so `$goalId` never reads `new` as a goal. */
function NewGoalRoute() {
  return (
    <LastWorkspaceResolver>
      <ShowGoalsGate>
        <PlanGuard excludedPlans={[BUILDER_PLAN_SLUG]}>
          <NewGoalRouteView />
        </PlanGuard>
      </ShowGoalsGate>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/goals/new')({
  component: NewGoalRoute,
  validateSearch: validateNewGoalSearch,
});
